/**
 * Created by 唐亦慧 on 2017/8/29.
 */

import {config, request, objectSerial} from 'Utils';


//获取品牌列表
export function brandList(param) {
	return request(`${config.server}/api/v1/dms/productBrand/list`,{
		method: 'post',
		body: param
	});
	
}


//品牌详情--传id
export function brandDetail(param) {
	return request(`${config.server}/api/v1/dms/productBrand/detail?${objectSerial(param)}`,{method: 'post'});
}


//品牌新增或修改
/*
*  {
 active (integer, optional): 启用状态（1有效，失效） ,
 code (string, optional): 品牌编码 ,
 description (string, optional): 品牌描述 ,
 id (integer, optional): 主键ID ,
 name (string, optional): 品牌名称 ,
 sortOrder (integer, optional): 排序
 }
* */
export function saveOrUpdate(param) {
	return request(`${config.server}/api/v1/dms/productBrand/saveOrUpdate`,{
		method: 'post',
		body: param
	});
}


//删除品牌
export function brandDelete(param) {
	return request(`${config.server}/api/v1/dms/productBrand/delete`,{
		method: 'post',
		body: param
	});
}



// WEBPACK FOOTER //
// ./src/service/productBrand/index.js